<template>
  <div class="mapping">
    <div class="content">
      <div class="search-input-btn" style="width:100%">
        <el-scrollbar style="height:100%;width: 100%;">
          <div class="my-search-i">
            <div class="input-small mr-20">
              <span>选择车间：</span>
              <el-select
                v-model="workshop"
                placeholder="请选择车间"
                @change="changeSelect"
              >
                <el-option
                  v-for="item in options"
                  :key="item.id"
                  :label="item.capacityName"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </div>
            <div class="input-small mr-20">
              <span>开始时间：</span>
              <el-date-picker
                v-model="startDate"
                type="date"
                placeholder="选择开始时间"
                :picker-options="pickerOptions"
              ></el-date-picker>
            </div>
            <div class="input-small myinput">
              <span>结束时间：</span>
              <el-date-picker
                v-model="endDate"
                type="date"
                placeholder="选择结束时间"
                :picker-options="pickerOptions"
              >
              </el-date-picker>
            </div>
            <el-button type="primary" @click="getList" plain class="search-btn"
              >查询</el-button
            >
            <el-button type="primary" @click="add_ed(0)" class="search-btn"
              >手工填报</el-button
            >
            <el-button type="primary" @click="exportList" class="search-btn"
              >导出</el-button
            >
          </div>
        </el-scrollbar>
      </div>

      <div class="mapping-table">
        <el-table
          :data="tableData"
          stripe
          style="width: 100%"
          :max-height="heights"
        >
          <template slot="empty">
            <span class="noData">
              <img src="@/assets/noData.png" alt="暂无数据" />
              <span class="text">暂无数据</span>
            </span>
          </template>
          <el-table-column label="序号" width="50" align="center">
            <template slot-scope="scope">
              <span>{{ scope.$index + 1 }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="capacityName" label="映射名称" min-width="305">
          </el-table-column>
          <el-table-column label="时间" min-width="204">
            <template slot-scope="scope"
              ><span>{{ scope.row.recordDay | date_format }}</span></template
            >
          </el-table-column>
          <el-table-column prop="capacityValue" label="产量" min-width="204">
          </el-table-column>
          <el-table-column label="填报类型" min-width="204">
            <template slot-scope="scope"
              ><span>{{
                scope.row.sourcesType == "REMOTE" ? "自动填报" : "手工填报"
              }}</span></template
            >
          </el-table-column>

          <el-table-column label="操作" align="center" width="124">
            <template #default="{row}">
              <span class="buttoned_box">
                <el-button
                  type="text"
                  @click="edit_ed(row, 0)"
                  v-if="row.sourcesType == 'REMOTE'"
                  style="color:#409eff;font-weight: bold"
                  >修正</el-button
                >
                <el-button
                  type="text"
                  @click="edit_ed(row, 1)"
                  v-else
                  style="color:#409eff;font-weight: bold"
                  >编辑</el-button
                >
              </span>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <downloadTable ref="downloadTable"></downloadTable>
    </div>

    <!-- 新增修改 -->
    <el-dialog
      width="30%"
      v-dialogDrag
      :title="textMap[dialogStatus]"
      :close-on-click-modal="false"
      :visible.sync="dialogVisible"
    >
      <div class="dialogs">
        <el-form
          :model="temp"
          ref="temp"
          :rules="rules"
          style="width: 80%;height: 180px;padding-top: 10px;"
        >
          <el-form-item label="映射名称:" prop="capacityName">
            <el-input v-model="temp.capacityName" disabled></el-input>
          </el-form-item>

          <el-form-item label="产量:" prop="capacityValue">
            <el-input v-model="temp.capacityValue"></el-input>
          </el-form-item>
          <el-form-item label="日期:" prop="recordDay">
            <el-date-picker
              v-model="temp.recordDay"
              type="date"
              size="mini"
              placeholder="选择日期"
              :disabled="editType == 0"
              :picker-options="pickerOptions"
            >
            </el-date-picker>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button
          type="primary"
          @click="dialogStatus === 'edit' ? edit_fn('temp') : add_fn('temp')"
          >保存</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  getMappingList,
  recordFindList,
  recordUpdateValue,
  recordSave,
  recordUpdateInfo,
} from "../../api/capacity";
import elRadioTree from "@/components/module/tree/elRadioTree.vue";
import downloadTable from "@/components/module/downloadTable/downloadTable.vue";
export default {
  components: {
    elRadioTree,
    downloadTable,
  },
  data() {
    return {
      heights: Math.round(document.getElementById("app").clientHeight * 0.77), //屏幕高度 - 导航栏高度
      loading: false,
      dialogVisible: false,
      dialogStatus: "",
      textMap: {
        add: "新增填报",
        edit: "编辑填报",
      },
      temp: {
        capacityName: "",
        localDevice: "",
        localDeviceNo: "",
      },
      rules: {
        capacityName: [
          { required: true, message: "请输入映射名称", trigger: "blur" },
        ],
        recordDay: [{ required: true, message: "请选择日期", trigger: "blur" }],
        capacityValue: [
          { required: true, message: "请输入产量", trigger: "blur" },
        ],
      },
      tableData: [
        {
          id: 342077290948609,
          sourcesId: 265406012200961,
          sourcesType: "REMOTE",
          capacityName: "",
          capacityValue: 1980,
          recordDay: 1719763200000,
          createTime: 1719847803000,
        },
        {
          id: 342254237575169,
          sourcesId: 265406012200961,
          sourcesType: "REMOTE",
          capacityName: "",
          capacityValue: 1874,
          recordDay: 1719849600000,
          createTime: 1719934203000,
        },
        {
          id: 342431185813505,
          sourcesId: 265406012200961,
          sourcesType: "REMOTE",
          capacityName: "",
          capacityValue: 1845,
          recordDay: 1719936000000,
          createTime: 1720020603000,
        },
        {
          id: 342608132890625,
          sourcesId: 265406012200961,
          sourcesType: "REMOTE",
          capacityName: "",
          capacityValue: 2064,
          recordDay: 1720022400000,
          createTime: 1720107003000,
        },
        {
          id: 342785079867393,
          sourcesId: 265406012200961,
          sourcesType: "REMOTE",
          capacityName: "",
          capacityValue: 2452,
          recordDay: 1720108800000,
          createTime: 1720193403000,
        },
        {
          id: 342962026696705,
          sourcesId: 265406012200961,
          sourcesType: "REMOTE",
          capacityName: "",
          capacityValue: 1603,
          recordDay: 1720195200000,
          createTime: 1720279803000,
        },
        {
          id: 343138973583361,
          sourcesId: 265406012200961,
          sourcesType: "REMOTE",
          capacityName: "",
          capacityValue: 0,
          recordDay: 1720281600000,
          createTime: 1720366203000,
        },
        {
          id: 343315920959489,
          sourcesId: 265406012200961,
          sourcesType: "REMOTE",
          capacityName: "",
          capacityValue: 1765,
          recordDay: 1720368000000,
          createTime: 1720452603000,
        },
        {
          id: 343492868272129,
          sourcesId: 265406012200961,
          sourcesType: "REMOTE",
          capacityName: "",
          capacityValue: 2693,
          recordDay: 1720454400000,
          createTime: 1720539003000,
        },
        {
          id: 343669816385537,
          sourcesId: 265406012200961,
          sourcesType: "REMOTE",
          capacityName: "",
          capacityValue: 2250,
          recordDay: 1720540800000,
          createTime: 1720625403000,
        },
      ],
      startDate: "",
      endDate: new Date(),
      options: [
        {
          id: 265406012200961,
          unitId: "6926D4E0F8DE4B53902D871494DC9C65",
          capacityName: "开料工序",
          measurement: "件",
          localDeviceNos: "-1776",
          localDevices: "一层车间#3配电箱1AP3总表(开料区)",
          remotDevice: "CU1,CU2,CU3",
          createTime: 1682410655000,
          status: "ENABLE",
        },
        {
          id: 265545791930369,
          unitId: "6926D4E0F8DE4B53902D871494DC9C65",
          capacityName: "封边工序",
          measurement: "件",
          localDeviceNos: "-1900",
          localDevices: "封边区当前有功电度",
          remotDevice:
            "EB2,EB3,111000143,111000144,111000145,111000146,111000147,111000148",
          createTime: 1682478907000,
          status: "ENABLE",
        },
        {
          id: 265548661825537,
          unitId: "6926D4E0F8DE4B53902D871494DC9C65",
          capacityName: "打孔工序",
          measurement: "件",
          localDeviceNos: "-1780",
          localDevices: "二楼车间#4配电箱2AP4总表(2楼排孔区)",
          remotDevice:
            "SKD612520151,SKD612520152,SKD612520153,SKD612520154SKD612520155,SKD612520156,SKD612520157,SKD612520158",
          createTime: 1682480308000,
          status: "ENABLE",
        },
        {
          id: 275792867999745,
          unitId: "6926D4E0F8DE4B53902D871494DC9C65",
          capacityName: "智造部空压机单品能耗",
          measurement: "件",
          localDeviceNos: "-1773",
          localDevices: "智造部空压机总表",
          remotDevice: "智造部",
          createTime: 1687482362000,
          status: "ENABLE",
        },
        {
          id: 275792993005569,
          unitId: "6926D4E0F8DE4B53902D871494DC9C65",
          capacityName: "智造部总单品能耗",
          measurement: "件",
          localDeviceNos: "-1971",
          localDevices: "智造部当前有功电度",
          remotDevice: "智造部",
          createTime: 1687482423000,
          status: "ENABLE",
        },
        {
          id: 275793107275777,
          unitId: "6926D4E0F8DE4B53902D871494DC9C65",
          capacityName: "吸尘设备单品能耗",
          measurement: "件",
          localDeviceNos: "-1777,-1778,-1779",
          localDevices:
            "F-6(封边PVC吸尘),F-3-1(1楼开料吸尘),一楼F-3(2楼排孔吸尘)",
          remotDevice: "智造部",
          createTime: 1687482479000,
          status: "ENABLE",
        },
        {
          id: 282926415194113,
          unitId: "6926D4E0F8DE4B53902D871494DC9C65",
          capacityName: "生产一部单品能耗",
          measurement: "件",
          localDeviceNos: "-1899",
          localDevices: "生产一部当前有功电度",
          remotDevice: "第一车间",
          createTime: 1690965539000,
          status: "ENABLE",
        },
        {
          id: 282926505162753,
          unitId: "6926D4E0F8DE4B53902D871494DC9C65",
          capacityName: "技术中心单品能耗",
          measurement: "件",
          localDeviceNos: "-1782",
          localDevices: "技术中心二楼",
          remotDevice: "技术中心",
          createTime: 1690965583000,
          status: "ENABLE",
        },
      ],
      nowWorkshop: {},
      workshop: "",
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
      editType: 0,
    };
  },

  mounted() {
    this.nowWorkshop = this.options[0];
    this.workshop = this.options[0].id;
    this.getList();
    this.getSelectList();
    var date = new Date();
    date.setDate(1);
    var cTime = new Date(new Date(date).toLocaleDateString()).getTime();
    this.startDate = cTime;
  },
  computed: {
    unitId() {
      return this.$store.unitStore.state.nowUnit;
    },
  },
  watch: {
    unitId() {
      this.getSelectList();
    },
  },

  methods: {
    //获取下拉框列表
    getSelectList() {
      var id = this.unitId.id;
    },
    //获取数据
    getList() {
      console.log(this.nowWorkshop.capacityName, 11);
      this.tableData.forEach(
        (item) => (item.capacityName = this.nowWorkshop.capacityName)
      );
    },
    //下拉框
    changeSelect(val) {
      var arr = this.options.filter((item) => item.id == val);

      this.nowWorkshop = arr[0];
      this.workshop = arr[0].id;
      this.getList();
    },

    // 添加弹窗
    add_ed(v, l) {
      this.editType = 1;
      this.temp = {};
      this.temp.capacityName = this.nowWorkshop.capacityName;
      this.dialogStatus = "add";
      this.dialogVisible = true;
      this.topLevel = v;
      this.$nextTick(() => {
        this.$refs["temp"].clearValidate();
      });
      // this.temp = { EnergyTypeParentId: v || null};
    },
    // 确认添加
    add_fn(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.dialogVisible = false;
        } else {
          return false;
        }
      });
    },

    // 确认编辑
    edit_fn() {
      this.$refs["temp"].validate((valid) => {
        if (valid) {
          this.dialogVisible = false;
        } else {
          return false;
        }
      });
    },
    //编辑弹窗 0 为自动填报，1为手工填报
    edit_ed(v, type) {
      if (type == 0) {
        this.textMap.edit = "修正自动填报";
      } else {
        this.textMap.edit = "编辑手工填报";
      }
      this.editType = type;

      this.dialogStatus = "edit";
      this.temp = Object.assign({}, v);
      this.temp.capacityName = this.nowWorkshop.capacityName;
      this.dialogVisible = true;
      this.$nextTick(() => {
        this.$refs["temp"].clearValidate();
      });
    },
    //下载表格excel
    exportList() {
      let time = new Date();
      let year = time.getFullYear();
      let month = time.getMonth() + 1;
      let day = time.getDate();

      const tHeader = [];
      this.$refs.downloadTable.export2Excel(
        tHeader,
        this.tableData,
        year + "-" + month + "-" + day + "-产量管理",
        ".mapping-table"
      );
    },
  },
  filters: {
    // 转换时间戳
    date_format: function(value) {
      //value就是插值的数据
      if (!value) {
        return "";
      }
      let date = new Date(value);
      let Y = date.getFullYear() + "-";
      let M =
        (date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1)
          : date.getMonth() + 1) + "-";
      let D =
        (date.getDate() < 10 ? "0" + date.getDate() : date.getDate()) + " ";
      let strDate = Y + M + D;
      return strDate;
    },
  },
};
</script>

<style lang="scss" scoped>
.mapping {
  width: 100%;
  height: 100%;
  background-color: #ebf4ff;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px;

  .content {
    width: 100%;
    height: 100%;
    padding: 2px 20px 20px 20px;
    box-sizing: border-box;
    background-color: #fff;

    .mapping-table {
      margin-top: 20px;

      /deep/.el-table th.is-leaf {
        border-bottom: 0px;
      }

      .buttoned_box {
        display: flex;
        justify-content: center;
        align-items: center;

        .line {
          display: inline-block;
          width: 1px;
          height: 20px;
          background-color: #e6e6e6;
          margin: 0px 20px;
        }

        .buttoned {
          cursor: pointer;
        }

        /deep/.el-button span {
          font-size: 15px;
          font-weight: 400;
        }
      }
    }
  }

  .dialogs {
    /deep/.el-input__inner {
      width: 250px;
    }
  }

  /deep/.el-dialog__header {
    display: flex;
    align-items: center;
    border-bottom: 1px solid #f5f5f5;

    span {
      color: #67a3ed;
      font-size: 16px;
    }

    .el-icon-close {
      font-size: 22px !important;
    }
  }

  /deep/.el-dialog__footer {
    margin-top: 20px;
    text-align: right !important;
    border-top: 1px solid #f5f5f5;

    button {
      padding: 8px 17px;
    }
  }

  /deep/.el_Tree_Body {
    height: 99.5%;
  }

  .demo-temp {
    display: flex;
    flex-wrap: wrap;
  }

  /deep/.el-form-item {
    display: flex;
    margin-left: 20px;
  }

  /deep/.el-form-item__label {
    white-space: nowrap;
    width: 85px;
  }

  /deep/.el-dialog__body {
    padding: 20px 0px 0px 20px !important;
  }
}
</style>
